(function() {
    'use strict';

    /**
     * @ngdoc service
     * @name common.service:ProductLayoutSvc
     * @description
     * 
     * En Confluence tenemos el detalle del objeto Xmedia
     */

    angular.module('itxApp.common')
        .factory('ProductLayoutSvc', ProductLayoutSvc);

    ProductLayoutSvc.$inject = [
        'itxAkamaiSvc',
        'ItxScreenSizeSvc'
    ];

    function ProductLayoutSvc(
        itxAkamaiSvc,
        ItxScreenSizeSvc
    ) {

        var service = {
            getLayoutProductPage: _getLayoutProductPage
        };
        return service;

        function _getLayoutProductPage(ArrayImages, definedWidth) {
            if (!ArrayImages) {
                return;
            }

            var layoutElements = _.map(ArrayImages, function(xmediaImg) {

                // TODO imagenes dobles en Producto
                // En el Slider de productos no podemos mostrar imagenes dobles
                if(ItxScreenSizeSvc.is('xs') && xmediaImg.clazz === 7){
                    return;
                }

                return new ElementLayout(xmediaImg, definedWidth);
            });

            return _.filter(layoutElements, function (element) {
                return (element);
            });
        }
        // ** Ratios definidos en afkl scss **
            // afkl-img-ratio-4-2
            // afkl-img-ratio-2-1
            // afkl-img-ratio-16-9
            // afkl-img-ratio-3-2
            // afkl-img-ratio-1-1
            // afkl-img-ratio-4-3
            // afkl-img-ratio-3-4
            // afkl-img-ratio-105
            // afkl-img-ratio-30 
            // afkl-img-ratio-21-9
        // ** Mapeo de Clazz ** 
            // 1 - Foto Principal
            // 2 - Foto Secundaria
            // 4 - Foto Silueta
            // 5 - Foto Silueta Especial
            // 7 - Foto Doble
            // 6 - Foto Alternativa
        function ElementLayout(xmedia, widthImages) {  
            this.widthElement = widthImages;

            if(!window.productPopupOpen) {
                //this.widthElement = $('#product-images-grid').width();
                var width = 2;
                if(ItxScreenSizeSvc.is('xs,sm')){
                    width = 1;
                }

                switch (xmedia.clazz) {
                    case 1:
                        this.classRatio = 'afkl-img-ratio-3-4';
                        this.className = 'img-principal';
                        this.widthElement = this.widthElement / width;
                        break;
    
                    case 7:
                        this.classRatio = 'afkl-img-ratio-3-2';
                        this.className = 'img-double';
                        break;
    
                    default:
                        this.classRatio = 'afkl-img-ratio-3-4';
                        this.className = 'img-secondary';
                        this.widthElement = this.widthElement / width;
                        break;
                }
            } 
                        
            this.imageUrl = itxAkamaiSvc.useAkamaiProductImage(xmedia.url, this.widthElement);;
            return this;
        }
    }
})();